module.exports = __webpack_public_path__ + "media/img/private-venue/distrii-259744b6fd4ff82cee514eca7ca92330.png";